import { tns } from 'tiny-slider';
import { breakpoints } from '../helpers/constants';
const slider = () => {
  const $quoteSlider = document.querySelectorAll('.quote-slider');
  if (!$quoteSlider.length) return;
  const sliderConf = {
    mouseDrag: true,
    nav: false,
    controls: false,
    items: 1.2,
    loop: false,
    rewind: true,
    autoplayButtonOutput: false,
    arrowKeys: true,
    autoplay: true,
    autoplayHoverPause: true,
    autoplayTimeout: 4000,
    responsive: {
      [breakpoints.md]: {
        items: 2
      },
      [breakpoints.xl]: {
        items: 3
      }
    }
  };
  $quoteSlider.forEach($slider => {
    const sliderItems = $slider.querySelectorAll('.tns-item');
    if (sliderItems.length <= 2) return;
    const $frame = $slider.closest('.frame');
    const $frameHeader = $frame.querySelector('.frame-header');
    $frame.style.setProperty('--bs-header-height', `${$frameHeader.offsetHeight}px`);
    tns(Object.assign(sliderConf, {
      container: $slider
    }));
  });
};
export default slider;